export default "__VITE_ASSET__b65874df__"